import React, { memo } from 'react';
import { createUseStyles, useTheme, Text } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';

const useStyles = createUseStyles(styles, 'BetaBadge');

const BetaBadge = memo(() => {
    const { t } = useWeb5Context();
    const theme = useTheme();
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Text type="badges" color={theme.colors.primary.white}>
                {t('label_beta')}
            </Text>
        </div>
    );
});

export default BetaBadge;
